import { mapInitialState } from "@iventis/map-engine/src/defaults/map-initial-state";
import { MappingEngine } from "@iventis/map-engine/src/types/store-schema";
import { LoadingEvent } from "@iventis/types/loading.types";
import { DomainMapState, MapGlobalState } from "./map.state.types";

export const defaultMappingEngine = MappingEngine.Mapbox;

// TODO: Store should be cleared when the map is navigated away from (reset to empty).
export const initialState: MapGlobalState = {
    waitingFor: [
        { id: "", eventName: LoadingEvent.GET_MAP },
        { id: "", eventName: LoadingEvent.GET_PROJECT_DATAFIELDS },
        { id: "", eventName: LoadingEvent.GET_SITEMAPS },
    ],
    incompleteDrawingObjects: [],
    savedMapViewWizard: {
        stage: null,
        mapViewId: null,
    },
    mapName: null,
    savedMapViews: null,
    savedMapViewDefault: null,
    savedBackgroundDefault: null,
    isPlacingGeometry: false,
    levels: [
        {
            index: 0,
            name: "Group Floor",
            abbreviation: "GF",
        },
    ],
    sitemaps: [],
    sitemapsInView: [],
    showMapObjectInformation: true,
    mapModule: mapInitialState as DomainMapState,
    signatures: [],
    objectsChangesSaving: [],
    mappingEngine: defaultMappingEngine,
    drawingToolTip: null,
    savedMapTooltip: false,
    isMapPanningAfterSearch: false,
    creatingObjects: [],
    failedToGetMap: null,
    showRoutePlanner: false,
    sitemapConfigs: [],
    selectedAnalysisTool: null,
    showBookmarks: false,
    takingScreenshot: false,
};
